import { useQuery } from "@apollo/client";

import { appParamsVar } from "graphql/cache";
import { GET_APP_PARAMS } from "graphql/query/local-store-gql";
import translation from "mock-data/translation";
import { getEnabledLanguage } from "mock-data/translation/languages";


const defaultLang = "en";

const getEffectiveTranslationLanguage = (appParams = appParamsVar()) => {
    const languageOverride = appParams.translationLanguageOverride,
          userLanguage = appParams.me && appParams.me.language_slug,
          translationLanguages = appParams.translationLanguages || [];

    if (languageOverride && getEnabledLanguage(languageOverride, translationLanguages)) return languageOverride;
    if (userLanguage && getEnabledLanguage(userLanguage, translationLanguages)) return userLanguage;

    return defaultLang;
};

export const getTranslations = (appParams = appParamsVar()) => {
    const lang = getEffectiveTranslationLanguage(appParams);

    return {
        ...translation[defaultLang],
        ...(translation[lang] || {})
    };
};

const useTranslation = () => {
    const { data : { appParams } = { appParams: appParamsVar() } } = useQuery(GET_APP_PARAMS);

    return getTranslations(appParams);
}

export default useTranslation;
